var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0626526,
    width: 14,
    height: 14,
    rx: 7,
    fill: "#909298"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6209 7.74081C10.7745 7.74076 10.9218 7.66926 11.0304 7.54204C11.139 7.41483 11.2 7.24231 11.2 7.06245C11.1999 6.88259 11.1389 6.71011 11.0302 6.58297C10.9215 6.45582 10.7742 6.38442 10.6205 6.38448C5.98066 6.38448 7.65465 6.38448 3.37182 6.38448C3.2195 6.38673 3.07407 6.45915 2.96704 6.58605C2.86001 6.71295 2.79999 6.88411 2.79999 7.06245C2.79999 7.24079 2.86001 7.41195 2.96704 7.53885C3.07407 7.66575 3.2195 7.73817 3.37182 7.74042C7.69736 7.74097 5.92944 7.74081 10.6209 7.74081Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRemove);
export default __webpack_public_path__ + "static/media/Icon-remove.972800bc.svg";
export { ForwardRef as ReactComponent };